// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ttgNe","image":"Header_image__33_30","name":"Header_name__olki9","info":"Header_info__zc_bu","infoRow":"Header_infoRow__3vqWO"};